import { VRButton, XR, Controllers, useController} from '@react-three/xr'
import { Sky} from '@react-three/drei'
import { Canvas, useThree } from '@react-three/fiber'
import {Quizquestion} from './quizquestion'
import { Resultpane } from './resultpane'
import {Plane, Text} from '@react-three/drei'
//import questions from './questions.json'

import { generateQuestions } from './questionutils'
import {OrbitControls} from '@react-three/drei'
import {useState, useEffect, useMemo} from 'react'
import {PerspectiveCamera, Float32BufferAttribute, AudioListener} from 'three'
import {useControls, Leva } from 'leva'
import {useXR} from '@react-three/xr'


function Floor() {
  return (
    <mesh rotation={[-Math.PI/2, 0, 0]}>
      <planeGeometry args={[40, 40]} />
      <meshStandardMaterial color="#666" />
    </mesh>
  )
}

const SetupSabers = () => {
  
  const leftController = useController('left')
  const rightController = useController('right')
  const state = useThree()
  const player = useXR((state) => state.player)
  
  useEffect(() => {
    state.raycaster.near=0.1;
    state.raycaster.far=1.5;
    state.camera.position.set(0,1.5,0);
    state.camera.far=10;
    state.camera.rotateZ(-Math.PI/4);
    player.position.set(0,0,0);
    if (leftController != null && leftController.controller!=null)
    {
      var myline = leftController.controller.children[0]; 
      if (myline!=null) {
        myline.name = "Left Ray"
        myline.material.color.set('hotpink');
        myline.material.linewidth = 10;
        myline.geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 0, 0, -1], 3));
      }
      //console.log(leftController);
    }
    if (rightController != null && rightController.controller!=null)
    {
      var myline = rightController.controller.children[0]; 
      if (myline!=null) {
        myline.name = "Right Ray"
        myline.material.color.set('limegreen');
        myline.material.linewidth = 10;
        myline.geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 0, 0, -1], 3));
      }
      //console.log(rightController);
    }
    
  }, [leftController, rightController, state, player])
  
}


export const  App = () => {
    //const texture = useLoader(TextureLoader, './img/planets.jpg')
    const [zpos, setZpos] = useState(-2)
    const [startgame, setStartgame] = useState(false)
    const [mathquestions, setMathquestions] = useState([])
    

    const options = useMemo(() => {
      return {
        difficulty : {value: 'easy', options: ['easy', 'medium', 'hard']},
        operation : {value: 'addition', options: ['addition', 'subtraction', 'multiplication', 'division']},
        speed : {value: 0.6, min: 0.2, max: 2, step: 0.1},
        count : {value: 4, min: 1, max: 100, step: 1}
      }
    }, [])
    
    const configuration = useControls(options);
    
    const mycamera = new PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 20 );
    const listener = new AudioListener();
		mycamera.add( listener );

		const audioElement = document.getElementById( 'music' );
    const whoosh = document.getElementById( 'whoosh' );
    
		
    const ShowGamePlay = () => {
      console.log("Showing GamePlay screen")
      return (
        <>
          <VRButton />
          <Canvas>
            <XR onSessionStart={(event) => { audioElement.play(); }} >
              <gridHelper args={[40, 40, 0xffff00, 'teal']} />
              <ambientLight />
              <pointLight position={[10, 10, 10]} />
              <Controllers />

              <SetupSabers />

              
              <group name="allquestions" position={[0, 1, zpos]}  >
                {mathquestions.map(
                  (question, index) => {
                     question.speed = configuration.speed;
                     question.zpos = index * -6;
                     return (<Quizquestion key={index} questionProps={question} whoosh={whoosh} answered={false} />)
                    }
                  )
                }
                <Resultpane count={configuration.count} speed={configuration.speed} setStartgame={setStartgame}/>
              </group>
              <OrbitControls target={[0, 1.5, -2]} />

            </XR>
          </Canvas>
        </>
      );
      
    }

  
  const ShowConfigScreen = () => {
    console.log("Showing config screen")
    return (
      <>
        <Leva isRoot={true} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <button onClick={() => { 
            setMathquestions(generateQuestions(configuration.count, configuration.operation, configuration.difficulty));
            setStartgame(true) 
            }}>
          Start Game
          </button>
        </div>
      </>
    );
  }
    console.log(startgame)
    if (startgame) {
      return (<ShowGamePlay />)
    }
    else {
      return (<ShowConfigScreen />)
    }
    

  }
  

const ScorePlane = ({score}) => {
  
  return (
    <Plane
      position={[0,0.5,-2]}
      args={[.5, .2]} // Width, height

    >
      <Text color="black" fontSize={0.1} position-z={0.01} >
        Score  {score}
      </Text>
    </Plane>
  );
}